import { GetterTree } from 'vuex'
import { RootState } from '@/store/types';
import { PushApplicationState } from './types';

export const getters: GetterTree<PushApplicationState, RootState> = {
  pushApplications: state => state.pushApplications,
  pushApplication: state => state.pushApplication,
  pushPlatforms: state => state.pushPlatforms,
  pushOS: state => state.pushOS
}
